import { render } from "./Investment.vue?vue&type=template&id=457ecb3a&scoped=true"
import script from "./Investment.vue?vue&type=script&lang=js"
export * from "./Investment.vue?vue&type=script&lang=js"

import "./Investment.vue?vue&type=style&index=0&id=457ecb3a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457ecb3a"]])

export default __exports__